import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);
const KEY = "inj_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* private mode */ }
  }, [items]);

  // item: {slug, tier, name, price, image, quantity}
  const add = (item) => {
    setItems((cur) => {
      const i = cur.findIndex((x) => x.slug === item.slug && x.tier === item.tier);
      if (i >= 0) {
        const next = [...cur];
        next[i] = { ...next[i], quantity: Math.min(10, next[i].quantity + item.quantity) };
        return next;
      }
      return [...cur, item];
    });
    setOpen(true);
  };
  const remove = (slug, tier) => setItems((cur) => cur.filter((x) => !(x.slug === slug && x.tier === tier)));
  const setQty = (slug, tier, quantity) =>
    setItems((cur) => cur.map((x) => (x.slug === slug && x.tier === tier
      ? { ...x, quantity: Math.max(1, Math.min(10, quantity)) } : x)));
  const clear = () => setItems([]);
  const count = items.reduce((n, x) => n + x.quantity, 0);
  const subtotal = items.reduce((n, x) => n + x.price * x.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, count, subtotal, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
